(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  const toast = (msg) => {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-on'), 1800);
  };

  const money = (cents) => {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' });
    } catch {
      return '₹' + (cents / 100).toFixed(0);
    }
  };

  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  async function cartAdd(id, qty = 1) {
    const res = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    });
    if (!res.ok) throw new Error('Could not add');
    await refreshCart();
    toast('Added to bag');
    openCart();
  }

  async function cartChange(key, qty) {
    await fetch(window.Shopify?.routes?.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    await refreshCart();
  }

  function renderCart(cart) {
    const body = $('[data-cart-body]');
    const sub = $('[data-cart-subtotal]');
    const ship = $('[data-ship-fill]');
    const shipText = $('[data-ship-text]');
    if (!body) return;
    setCartCount(cart.item_count);
    if (sub) sub.textContent = cart.items_subtotal_price != null ? money(cart.items_subtotal_price) : cart.items_subtotal_price;
    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty"><p>Your bag is empty</p><a class="btn btn--dark" href="${window.Shopify?.routes?.root || '/'}">Continue shopping</a></div>`;
    } else {
      body.innerHTML = cart.items
        .map(
          (item) => `
        <div class="cart-line">
          <img src="${item.image ? item.image + '&width=200' : ''}" alt="">
          <div>
            <strong>${item.product_title}</strong>
            <div class="price"><span class="price__current">${money(item.final_line_price)}</span></div>
            <div class="qty">
              <button type="button" data-qty-minus="${item.key}">−</button>
              <input value="${item.quantity}" readonly>
              <button type="button" data-qty-plus="${item.key}" data-qty="${item.quantity}">+</button>
            </div>
          </div>
          <button type="button" data-remove="${item.key}" aria-label="Remove">✕</button>
        </div>`
        )
        .join('');
    }
    const threshold = Number($('[data-ship-threshold]')?.dataset.shipThreshold || 99900);
    if (ship && shipText) {
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      ship.style.width = pct + '%';
      shipText.textContent =
        cart.total_price >= threshold
          ? 'You have unlocked free shipping'
          : `Add ${money(threshold - cart.total_price)} more for free shipping`;
    }
  }

  async function refreshCart() {
    const res = await fetch(window.Shopify?.routes?.root + 'cart.js');
    const cart = await res.json();
    renderCart(cart);
    return cart;
  }

  const openCart = () => $('.cart-drawer')?.classList.add('is-open');
  const closeCart = () => $('.cart-drawer')?.classList.remove('is-open');

  document.addEventListener('click', async (e) => {
    const add = e.target.closest('.js-quick-add');
    if (add) {
      e.preventDefault();
      try {
        await cartAdd(add.dataset.variantId);
      } catch {
        toast('Could not add this item');
      }
    }

    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      await refreshCart();
      openCart();
    }
    if (e.target.closest('[data-close-cart]') || e.target.classList.contains('cart-drawer__overlay')) closeCart();

    if (e.target.closest('[data-open-search]')) {
      e.preventDefault();
      $('.search-modal')?.classList.add('is-open');
      $('.search-modal input')?.focus();
    }
    if (e.target.closest('[data-close-search]') || e.target.classList.contains('search-modal__overlay')) {
      $('.search-modal')?.classList.remove('is-open');
    }

    if (e.target.closest('[data-open-menu]')) $('.mobile-nav')?.classList.add('is-open');
    if (e.target.closest('[data-close-menu]') || e.target.classList.contains('mobile-nav__overlay')) {
      $('.mobile-nav')?.classList.remove('is-open');
    }

    const wish = e.target.closest('.js-wishlist');
    if (wish) {
      const list = new Set(JSON.parse(localStorage.getItem('saba-wish') || '[]'));
      const h = wish.dataset.handle;
      if (list.has(h)) list.delete(h);
      else list.add(h);
      localStorage.setItem('saba-wish', JSON.stringify([...list]));
      wish.classList.toggle('is-on', list.has(h));
    }

    const minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      const line = minus.closest('.cart-line');
      const input = line.querySelector('input');
      const next = Math.max(0, Number(input.value) - 1);
      await cartChange(minus.dataset.qtyMinus, next);
    }
    const plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      const line = plus.closest('.cart-line');
      const input = line.querySelector('input');
      await cartChange(plus.dataset.qtyPlus, Number(input.value) + 1);
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) await cartChange(remove.dataset.remove, 0);
  });

  $$('.js-wishlist').forEach((btn) => {
    const list = new Set(JSON.parse(localStorage.getItem('saba-wish') || '[]'));
    if (list.has(btn.dataset.handle)) btn.classList.add('is-on');
  });

  $$('[data-variant-card]').forEach((card) => {
    card.addEventListener('click', () => {
      $$('[data-variant-card]').forEach((c) => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      const id = card.dataset.variantId;
      const input = $('[name="id"]');
      if (input) input.value = id;
      const price = $('[data-pdp-price]');
      if (price && card.dataset.price) price.innerHTML = card.dataset.price;
    });
  });

  const pdpForm = $('[data-product-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', async (e) => {
      if (!$('.cart-drawer')) return;
      e.preventDefault();
      const id = pdpForm.querySelector('[name="id"]').value;
      const qty = pdpForm.querySelector('[name="quantity"]')?.value || 1;
      try {
        await cartAdd(id, Number(qty));
      } catch {
        pdpForm.submit();
      }
    });
  }

  $$('[data-acc]').forEach((btn) => {
    btn.addEventListener('click', () => btn.closest('.pdp-acc')?.classList.toggle('is-open'));
  });

  $$('[data-toggle-usps]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const list = btn.parentElement.querySelector('[data-usps]');
      list?.classList.toggle('is-open');
      btn.classList.toggle('is-open');
    });
  });

  const desc = $('[data-desc]');
  const descBtn = $('[data-desc-toggle]');
  if (desc && descBtn) {
    descBtn.addEventListener('click', () => {
      const open = desc.classList.toggle('is-open');
      descBtn.textContent = open ? 'Read less' : 'Read more';
    });
  }

  const moreVars = $('[data-more-variants]');
  if (moreVars) {
    moreVars.addEventListener('click', () => {
      const wrap = $('[data-variant-wrap]');
      wrap?.classList.remove('is-collapsed');
      moreVars.remove();
    });
  }

  $('[data-share]')?.addEventListener('click', async () => {
    const data = { title: document.title, url: location.href };
    try {
      if (navigator.share) await navigator.share(data);
      else {
        await navigator.clipboard.writeText(location.href);
        toast('Link copied');
      }
    } catch {}
  });

  const stage = $('[data-gallery-stage]');
  const thumbs = $$('[data-gallery-thumb]');
  const dots = $$('[data-gallery-dots] button');
  const setGallery = (index) => {
    if (!stage) return;
    const slide = stage.children[index];
    if (slide) stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    thumbs.forEach((b, i) => b.classList.toggle('is-active', i === index));
    dots.forEach((b, i) => b.classList.toggle('is-on', i === index));
  };
  thumbs.forEach((btn, i) => btn.addEventListener('click', () => setGallery(i)));
  dots.forEach((btn, i) => btn.addEventListener('click', () => setGallery(i)));
  if (stage) {
    stage.addEventListener('scroll', () => {
      const i = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
      thumbs.forEach((b, n) => b.classList.toggle('is-active', n === i));
      dots.forEach((b, n) => b.classList.toggle('is-on', n === i));
    });
  }

  const sticky = $('[data-sticky-atc]');
  const buy = $('.pdp-actions');
  if (sticky && buy && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => sticky.classList.toggle('is-show', !entry.isIntersecting),
      { threshold: 0.2 }
    );
    io.observe(buy);
  }

  $$('[data-variant-card]').forEach((card) => {
    card.addEventListener('click', () => {
      const stickyPrice = $('[data-sticky-price] .price__current');
      if (stickyPrice && card.dataset.price) stickyPrice.textContent = card.dataset.price;
    });
  });

  $$('[data-reel-track]').forEach((track) => {
    const wrap = track.closest('.reel-wrap');
    const gap = parseInt(getComputedStyle(track).gap, 10) || 18;
    const step = () => {
      const card = track.querySelector('.reel-card');
      return card ? card.getBoundingClientRect().width + gap : 240;
    };
    wrap?.querySelector('[data-reel-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    wrap?.querySelector('[data-reel-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    const videos = $$('video.reel-video', track);
    if (!videos.length || !('IntersectionObserver' in window)) {
      videos.forEach((v) => v.play().catch(() => {}));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.45) video.play().catch(() => {});
          else video.pause();
        });
      },
      { root: null, threshold: [0, 0.45, 1] }
    );
    videos.forEach((video) => io.observe(video));
  });

  refreshCart().catch(() => {});
})();
